import React from "react";
import "./styles/index.css";
// import "./index.css";
import './styles/global-accessibility.css';
import ReactDOM from "react-dom/client";
import App from "./App";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";
import { AuthProvider } from "./AuthContext";


const msalInstance = new PublicClientApplication(msalConfig);


// // Disable right-click context menu globally
window.addEventListener('contextmenu', function (e) {
    e.preventDefault();
});

// Block common DevTools keyboard shortcuts
window.addEventListener('keydown', function (e) {
    // F12
    if (e.key === 'F12') {
        e.preventDefault();
        e.stopPropagation();
    }
    // Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+Shift+C, Ctrl+U
    if ((e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'J' || e.key === 'C')) ||
        (e.ctrlKey && e.key === 'u')) {
        e.preventDefault();
        e.stopPropagation();
    }
});

async function startApp() {
    await msalInstance.initialize();

    ReactDOM.createRoot(document.getElementById("root")!).render(
        <MsalProvider instance={msalInstance}>
            <AuthProvider>
                <App />
            </AuthProvider>
        </MsalProvider>
    );
}

startApp();